var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"flex items-center",attrs:{"to":"/"}},[_c('img',{staticClass:"object-contain h-7 mr-3",attrs:{"src":require("@/assets/images/logo.png"),"alt":"logo"}}),_c('div',{class:[
      'text-2xl font-black tracking-tighter uppercase',
      _vm.dark ? 'text-light' : 'text-dark'
    ]},[_vm._v(" Revv ")])])}
var staticRenderFns = []

export { render, staticRenderFns }